<script>
import { menuItems } from '@/components/horizontal-menu';
export default {
  name: "SetCampus",
  data() {
    return {
      campus: 0,
      campuses: [],
      realCampus: [],
      dus: [],
      realDUs: [],
      isAdmin: this.$store.state.decrypt.isAdmin(),
      selectedDU: 0,
      getDULoading: false,
      getDepartmentLoading: false,
      departments: [],
      realDepartments: [],
      selectedDepartment: 0
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("set-du-modal");
    },
    dropData() {
      let duSelected = this.realDUs.find((item) => item.id == this.selectedDU);
      let campusSelected = this.realCampus.find((item) => item.id == duSelected.campusId);
      let departmentSelected = {};
      if(this.isAdmin){
        departmentSelected = this.realDepartments.find((item) => item.id == this.selectedDepartment);
      }else{
        let fDepartment = this.realDepartments.find((item) => item.departmentId == this.selectedDepartment);
        departmentSelected = fDepartment ? { id: fDepartment.departmentId, departmentName: fDepartment.department } : {};
      }
      if(!campusSelected && !this.$store.state.data.selectedCampus){
        return this.showToast('Please contact administrator for this error', 'error')
      }
      this.hideDU(duSelected, true);
      this.hideDepartment(this.selectedDepartment);
      this.$store.commit("data/changeDU", duSelected);
      this.$store.commit("data/changeDepartment", departmentSelected ? departmentSelected : {});
      this.$bvModal.hide("set-du-modal");
      this.$emit("changeDU", duSelected);
      if(campusSelected){
        this.$emit("changeCampus", campusSelected);
        this.$store.commit("data/changeCampus", campusSelected);
      }
      this.$emit("changeDepartment", departmentSelected ? departmentSelected : {});
    },
    async getDUs($event) {
        this.getDULoading = true;
        this.selectedDU = 0;
        this.selectedDepartment = 0;
        if(!this.isAdmin){
          this.dus = []
          this.realDUs.filter(du => du.campusId == $event).map(du => {
            this.dus.push({ value: du.id, text: du.name });
          });
          this.selectedDU = this.dus.length > 0 ? this.dus[0].value : 0;
          this.getDepartmentsByDU(this.selectedDU);
        }else{
          if($event == 0){
            await this.$store
              .dispatch("deliveryunit/GetDeliveryUnit", $event)
              .then((response) => {
                  this.realDUs = response.data;
                  var dus = [{ text: "", value: 0 }];
                  response.data.forEach(item => {
                      dus.push({ value: item.id, text: item.name })
                  })
                  this.dus = dus;
              })
              .catch((error) => {
                  this.showToast('Something went wrong', 'error')
              });
          }else{
            await this.$store
              .dispatch("deliveryunit/GetDeliveryUnitByCampus", $event)
              .then((response) => {
                  this.realDUs = response.data;
                  var dus = [{ text: "", value: 0 }];
                  response.data.forEach(item => {
                      dus.push({ value: item.id, text: item.name })
                  })
                  this.dus = dus;
              })
              .catch((error) => {
                  this.showToast('Something went wrong', 'error')
              });
          }
        }
        this.getDULoading = false;
    },
    async resetData(){
      if(this.isAdmin){
        this.campus = this.$store.state.data.selectedCampus.id;
        await this.getDUs(this.$store.state.data.selectedCampus.id);
        await this.getDepartmentsByDU(this.$store.state.data.selectedDU.id);
      }
      this.selectedDU = this.$store.state.data.selectedDU.id;
    },
    async getDepartmentsByDU($event) {
      if(!this.isAdmin){
        this.departments = [];
        this.realDepartments = [];
        let fDU = this.realDUs.find(du => du.id == $event);
        if(!fDU) return;
        this.realDepartments = fDU.departmentAccess;
        fDU.departmentAccess.map(department => {
          this.departments.push({ value: department.departmentId, text: department.department })
        });
        this.selectedDepartment = this.departments.length > 0 ? this.departments[0].value : 0;
      }else{
        await this.$store
          .dispatch("department/GetDepartmentByDU", $event)
          .then((response) => {
              if(response.data.error){
                return this.showToast(response.data.errorMessage, 'error')
              }
              this.realDepartments = JSON.parse(JSON.stringify(response.data));
              this.departments = [];
              var departments = [{ text: "", value: 0 }];
              response.data.forEach(item => {
                departments.push({ value: item.id, text: item.departmentName })
              })
              this.departments = departments;
              if(response.data.length > 0){
                this.selectedDepartment = this.$store.state.data.selectedDepartment ? this.$store.state.data.selectedDepartment.id : response.data[0].id;
              }else{
                this.selectedDepartment = 0;
              }
          })
          .catch((error) => {
              this.showToast('Something went wrong', 'error')
          });
      }
    },
    setMenuItems(){
      let subItems = menuItems[1].subItems;
      let actualMenu = subItems.find(item => item.elementID == 'menu-actual');
      let planningMenu = subItems.find(item => item.elementID == 'menu-planning');
      let procMenu = subItems.find(item => item.elementID == 'procurement-menu');
      if(actualMenu){
        actualMenu.subItems.map(item => {
          item.display = true;
        })
      }
      if(planningMenu){
        planningMenu.subItems.map(item => {
          item.display = true;
        })
      }
      if(procMenu){
        procMenu.subItems.map(item => {
          item.display = true;
        })
      }
    },
    hideDepartment(existDepartmentMenu){
      if(this.isAdmin) return;
      let existMenu = document.getElementById('menu-department');
      if(!existMenu) return;
      let firstChild = existMenu.querySelector('.topnav-comps');
      if(!firstChild) return;
      if(existMenu){
        if(existDepartmentMenu && existDepartmentMenu > 0){
          firstChild.style.display = 'block';
        }else{
          if(this.$route.path.includes('department')){
            this.$router.push('/');
          }
          firstChild.style.display = 'none';
        }
      }else{
        firstChild.style.display = 'none';
      }
    },
    hideDU(existDUMenu, willReload = false){
      if(this.isAdmin) return;
      let existMenu = document.getElementById('menu-delivery-unit');
      let firstChild = existMenu.querySelector('.topnav-comps');
      if(!existMenu) return;
      if(!existDUMenu) return;
      if(!firstChild) return;
      if(existDUMenu.withDeliveryUnitAccess){
        firstChild.style.display = 'block';
        if(willReload) {
          this.setMenuItems();
        }
      }else{
        if(this.$route.path.includes('office')){
          this.$router.push('/');
        }
        firstChild.style.display = 'none';
      }
    },
  },
  async mounted() {
    var campuses = [];
    var dus = [{ text: "", value: 0 }];
    this.realCampus = [];
    this.$store.state.decrypt.campusAccessList().forEach((item) => {
        campuses.push({ value: item.Id, text: item.CampusName });
        this.realCampus.push({
          id: item.Id,
          campusName: item.CampusName,
          shortName: item.ShortName,
          isExternal: item.IsExternal,
        })
    });
    if(this.isAdmin){
        await this.getDUs(this.$store.state.data.selectedDU ? this.$store.state.data.selectedDU.campusId : 0)
        if(this.$store.state.data.selectedDU){
          this.getDepartmentsByDU(this.$store.state.data.selectedDU.id)
        }
    }else{
      let userAccess = JSON.parse(localStorage.getItem('user'));
      if(userAccess){
        let userCampus = userAccess.department.deliveryUnit.office.campus;
        if(!campuses.find(campus => campus.value == userCampus.id)){
          campuses.push({ value: userCampus.id, text: userCampus.campusName });
          this.realCampus.push(userCampus);
        }
      }
      if(localStorage.getItem('duAccess')){
        let duAccess = JSON.parse(localStorage.getItem('duAccess'));
        duAccess.forEach((item) => {
          if(item.campusId == this.$store.state.data.selectedDU.campusId){
            dus.push({ value: item.id, text: item.name })
          }
        })
        this.realDUs = duAccess;
        if(userAccess){
          let userDU = {
            ...userAccess.department.deliveryUnit, 
            withDeliveryUnitAccess: userAccess.withDeliveryUnitAccess, 
            departmentAccess: [
              {
                departmentId: userAccess.department.id,
                department: userAccess.department.departmentName,
                deliveryUnitId: userAccess.department.deliveryUnitId
              }
            ]
          };
          delete userDU['office'];
          if(!dus.find(du => du.value == userDU.id)){
            if(userDU.campusId == this.$store.state.data.selectedDU.campusId){
              dus.push({ value: userDU.id, text: userDU.name });
            }
            this.realDUs.push(userDU);
          }
          let departments = [];
          if(userAccess.department.deliveryUnitId == this.$store.state.data.selectedDU.id){
            let fDU = duAccess.find(du => du.id == userAccess.department.deliveryUnitId);
            if(fDU){
              departments = fDU.departmentAccess;
            }
          }else{
            departments = this.$store.state.data.selectedDU.departmentAccess;
          }
          this.realDepartments = departments;
          this.departments = this.realDepartments.map(department => {
            return { value: department.departmentId, text: department.department }
          });
        }
      }
      this.dus = dus;
    }
    this.campuses = campuses;
    this.campus = this.$store.state.data.selectedDU.campusId;
    this.selectedDU = this.$store.state.data.selectedDU.id;
    this.selectedDepartment = this.$store.state.data.selectedDepartment ? this.$store.state.data.selectedDepartment.id : 0;
    this.hideDU(this.$store.state.data.selectedDU);
    this.hideDepartment(this.selectedDepartment);
  },
};
</script>

<template>
  <b-modal
    id="set-du-modal"
    title="Set Delivery Unit"
    size="md"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="mb-3">
      <label for="name">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
      <b-form-select
        v-model="campus"
        :options="campuses"
        class="form-select"
        @change="getDUs"
      ></b-form-select>
    </div>
    <div class="mb-3">
      <label for="name">Delivery Unit </label>
      <b-form-select
        v-if="!getDULoading"
        v-model="selectedDU"
        :options="dus"
        @change="getDepartmentsByDU"
        class="form-select"
      ></b-form-select>
      <b-spinner v-else type="grow" small variant="success" class="ms-2"></b-spinner>
    </div>
    <div class="mb-3" v-if="realDepartments.length">
      <label for="name">Department </label>
      <b-form-select
        v-if="!getDepartmentLoading"
        v-model="selectedDepartment"
        :options="departments"
        class="form-select"
      ></b-form-select>
      <b-spinner v-else type="grow" small variant="success" class="ms-2"></b-spinner>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="dropData">Set Delivery Unit</button>
      <button type="button" class="btn btn-link" @click="hideModal">Close</button>
    </div>
  </b-modal>
</template>
